<template>
    <div id="app"
    >
        <div class="bgImage"
             v-bind:style="{ backgroundImage: 'url(' + bgImage + ')' }"></div>
        <transition>
            <router-view
                v-bind:selectEnvironments="selectEnvironments"
                v-bind:activeEnv="activeEnv"
                v-bind:envListImages="envListImages"
                v-on:addEnv="addEnv"
                v-on:removeEnv="removeEnv"
                v-on:setActiveEnv="setActiveEnv"
            />
        </transition>
        <div class="copyright"
             v-if="!preloadPage"
             v-bind:class="[this.$route.name]"
        >©2016 - 2022 Computacenter (UK) Ltd
        </div>
    </div>
</template>


<script>

    import {mapGetters} from 'vuex'

    export default {
        name: 'app',
        components: {},
        data() {
            return {
                selectEnvironments: [],
                activeEnv: false,
                headers: 'computacentar',
                envListImages: false,
            }
        },
        computed: {
            ...mapGetters({
                preloadPage: 'environments/preloadPage',
                environments: 'environments/environments',
                bgImage: 'environments/bgImage',
            }),
        },
        created() {
            document.title = "WPP is a creative transformation company | WPP";
        },

        mounted() {

            this.setHeight();
            window.addEventListener('resize', this.setHeight);
            if (localStorage.selectEnvironments) {
                try {
                    this.selectEnvironments = JSON.parse(localStorage.getItem('selectEnvironments'));
                } catch (e) {
                    localStorage.removeItem('selectEnvironments');
                }
            }
            if (localStorage.activeEnv) {
                try {
                    this.activeEnv = JSON.parse(localStorage.getItem('activeEnv'));
                } catch (e) {
                    localStorage.removeItem('activeEnv');
                }
            }
            this.createImageEnvList()
        },
        methods: {
            setHeight() {
                let vw = 1
                let vf = 1
                let vi = 1
                let vfx = 1
                // fix for browser viewport units on mobile
                const maxW = 1508;
                // const maxI = 1920;
                const minW = 1260;
                if (window.innerWidth < maxW && window.innerWidth > minW) {
                    let koef = Math.round((window.innerWidth - minW) * 100 / (maxW - minW)) / 100;
                    vw = 0.5 + 0.5 * koef;
                    vf = 0.6 + 0.4 * koef;
                    vi = 0.3 + 0.6 * koef;
                    vfx = 0.9 + 0.1 * koef;
                }
                if (window.innerWidth < 1480 && window.innerWidth > 1400) {
                    vi = vi * 0.7;
                    vw = vw * 0.7;
                }
                // if (window.innerWidth < maxI && window.innerWidth > minW ) {
                //     let koef = Math.round((window.innerWidth-1140)*100/(maxI-minW))/100;
                //     vi = 0.2+0.8*koef;
                // }
                document.documentElement.style.setProperty('--vw', `${vw}`);
                document.documentElement.style.setProperty('--vf', `${vf}`);
                document.documentElement.style.setProperty('--vi', `${vi}`);
                document.documentElement.style.setProperty('--vfx', `${vfx}`);
            },
            setActiveEnv(env_id) {
                let active_env = false;
                let elEnv = this.environments.filter((el) => {
                    return el.id == env_id;
                });

                if (elEnv[0].grouptype) {
                    let subEnv = this.environments.filter((el) => {
                        return el.parent == env_id;
                    });
                    active_env = subEnv[0].id
                } else {
                    active_env = env_id;
                }
                this.activeEnv = active_env;
                const parsed = JSON.stringify(this.activeEnv);
                localStorage.setItem('activeEnv', parsed);
            },

            addEnv(id) {
                if (this.selectEnvironments.indexOf(id) == -1) {
                    this.selectEnvironments.push(id);
                }
                this.saveSelectEnvironments();
            },
            removeEnv(id) {
                this.selectEnvironments = this.selectEnvironments.filter(function (item) {
                    return item !== id
                })
                this.saveSelectEnvironments();
            },
            saveSelectEnvironments() {
                const parsed = JSON.stringify(this.selectEnvironments);
                localStorage.setItem('selectEnvironments', parsed);
            },
            getCheldrens() {
                var elem = false;
                return elem;
            },
            // getParent() {
            //     let parent = false;
            //     return false;
            // },
            createImageEnvList() {
                // foce load images
                let navList = [];
                this.environments.forEach((item) => {
                    if (item.image) {
                        navList.push(item.image)
                    }
                    if (item.image_smart) {
                        navList.push(item.image_smart)
                    }
                    if (item.icon) {
                        navList.push(item.icon)
                    }
                });
                this.envListImages = navList;
            },
        }

    }
</script>
